<template>
  <div class="product">
    <p v-if="most_popular" class="text-center most-popular">
      <img :src="require(`app/assets/images/fire.png`)"/>
      75% of People Add
      <img :src="require(`app/assets/images/fire.png`)"/>
    </p>
    <div class="product-info-row">
      <div class="image-and-name">
        <div class="image-and-info">
          <img :src="require(`app/assets/images/${thumbnail}`)">
          <a href="" @click.prevent="show_details_modal()">ⓘ DETAILS</a>
          <ProductDetailsModal :show='details_modal' :cancel='close_details_modal'>
            <slot></slot>

            <template v-slot:actions>
              <a @click.prevent='close_details_modal' class='btn btn-cancel'>No Thanks</a>
              <a @click.prevent='add_product_and_close_modal()' class='btn'>Add</a>
            </template>
          </ProductDetailsModal>
        </div>

        <div class="name">
          <span class="product-name">{{title}}</span><br>
          <div class="product-description">{{description}}</div>
        </div>
      </div>
      <div class="price-and-quantity">
        <div class="price">
          <span class="retail-price" v-if="sale_price < retail_price">{{ format_currency(retail_price) }}</span>
          <span class="sale-price">{{ format_currency(sale_price) }}</span>
          <span class="discount" v-if="sale_price < retail_price">
            (SAVE {{ format_currency(retail_price - sale_price) }})
          </span>
        </div>

        <AddProductButton
          :added="added"
          :quantity="quantity"
          v-on:add="add_product"
          :min_limit="minimum_quantity"
          v-on:update_quantity="update_quantity" />
      </div>
    </div>
  </div>
</template>

<script>
  import { format_currency } from 'app/helpers/CurrencyHelpers'
  import AddProductButton from 'app/components/orders/AddProductButton'
  import ProductDetailsModal from 'app/components/orders/ProductDetailsModal'

  export default {
    props: [
      'add_button_clicked',
      'title',
      'description',
      'thumbnail',
      'retail_price',
      'sale_price',
      'quantity',
      'min_limit',
      'most_popular'
    ],
    data () {
      return {
        added: this.quantity > 0,
        minimum_quantity: this.min_limit || 0,
        details_modal: false
      }
    },
    methods: {
      format_currency,
      add_product() {
        this.added = true
      },
      update_quantity(val) {
        if (val < 0) val = 0
        if (val < this.minimum_quantity) val = this.minimum_quantity
        if (val == 0) this.added = false
        this.$emit('update_quantity', val)
      },
      add_product_and_close_modal () {
        if (this.quantity == 0) {
          this.update_quantity(1)
        }
        this.add_product()
        this.close_details_modal()

      },
      show_details_modal () {
        this.details_modal = true
      },
      close_details_modal () {
        this.details_modal = false
      }
    },
    components: {
      AddProductButton,
      ProductDetailsModal
    }
  }
</script>
